<template>
	<div>
		<div class="smallLoader" v-show="loading"></div>
		<div v-show="!loading" class="row" :class="!showDescription ? 'col-lg-6' : ''">
			<button type="button"
					class="btn btn-link btn-primary text-left col-6 m-0"
					@click.stop="download">
				<i class="fas fa-download"></i>
				{{ file.name || file.fileName }}
			</button>
			<div class="col-lg-6" v-if="showDescription">
				<input type="text" class="form-control" v-model="file.description" readonly />
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		file: Object,
		showDescription: {
			type: Boolean,
			default: true
		},
		path: {
			type: String,
            default: 'api/file/download'
		},
        type: {
			type: String,
			default: ''
        }
	},
	data() {
		return {
			baseUrl: this.$store.getters.baseUrl,
			loading: false
		};
	},
    methods: {
        download() {
            this.loading = true;
            const downloadUri = `${this.$store.getters.baseUrl}/${this.path}?id=${this.file.id}&type=${this.type}&hash=${this.file.hash}`;

            this.$http.get(downloadUri, { responseType: 'blob' })
				.then(response => {
					const blob = new Blob([response.data]);
					const url = window.URL.createObjectURL(blob);
					const link = document.createElement('a');
					link.href = url;
                    link.target = "_blank";
					link.setAttribute('download', (this.file.name || this.file.fileName)); // or any other extension
					document.body.appendChild(link);
					link.click();
					window.URL.revokeObjectURL(url);
				})
				.catch(err => {
					this.$vs.notify({
						color: 'danger',
						title: this.$t('notifications.error'),
						text: this.$helpers.errorText(err)
					})
				})
				.then(() => { this.loading = false; });
        }
    }
};
</script>

<style scoped>
input[readonly] {
	background-color: whitesmoke;
}

textarea[readonly] {
	background-color: whitesmoke;
}

.row {
	margin-bottom: 5px;
}
</style>
